<app-splash *ngIf="showSplash" (done)="showSplash = false" @fadeInOut></app-splash>

<main class="app-content" [class.visible]="!showSplash">
  <div *ngIf="!showSplash" @fadeInOut class="app-container">
    <a href="/events"><img src="assets/hires-logo.png" alt="Logo" class="logo" *ngIf="!showSplash" /></a>
    <!-- Your main app content -->
    <router-outlet />
   </div>
</main>